import React, { useState } from "react";
import { PageHeader } from "../components/shared/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { ComposeBroadcastCard } from "../components/notifications/ComposeBroadcastCard";
import { ComposeCustomerCard } from "../components/notifications/ComposeCustomerCard";
import { TodaysMenuCard } from "../components/notifications/TodaysMenuCard";
import { OtherUpdateCard } from "../components/notifications/OtherUpdateCard";
import { NotificationHistoryTab } from "../components/notifications/NotificationHistoryTab";
import { useListState } from "../hooks/useListState";

export default function Notifications() {
  const [historyKey, setHistoryKey] = useState(0);
  const [activeTab, setActiveTab] = useListState("notifications.activeTab", "app-updates");

  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" description="App updates (Today's Menu & broadcasts), push notifications, and send history." />
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList data-testid="notifications-tabs">
          <TabsTrigger value="app-updates" data-testid="notifications-tab-app-updates">App Updates</TabsTrigger>
          <TabsTrigger value="compose" data-testid="notifications-tab-compose">Push</TabsTrigger>
          <TabsTrigger value="history" data-testid="notifications-tab-history">History &amp; Log</TabsTrigger>
        </TabsList>
        <TabsContent value="app-updates">
          <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
            <TodaysMenuCard />
            <OtherUpdateCard onSent={() => setHistoryKey((k) => k + 1)} />
          </div>
        </TabsContent>
        <TabsContent value="compose">
          <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
            <ComposeBroadcastCard onSent={() => setHistoryKey((k) => k + 1)} />
            <ComposeCustomerCard />
          </div>
        </TabsContent>
        <TabsContent value="history">
          <NotificationHistoryTab key={historyKey} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
